import { type TFunction } from 'i18next';

import {
    type ReportWidgetConfig,
    type ReportWidgetInteractionPayload,
} from 'widgets/ComposableReportWidget';

interface GetProductPurchasesWidgetConfigProps {
    t: TFunction;
    canLoadMorePurchases: boolean;
    loadMorePurchases: () => void;
    onOrderDetailsClick: (payload: ReportWidgetInteractionPayload) => void;
}

export const getProductPurchasesWidgetConfig = ({
    t,
    canLoadMorePurchases,
    loadMorePurchases,
    onOrderDetailsClick,
}: GetProductPurchasesWidgetConfigProps): ReportWidgetConfig => ({
    widgetId: 'spend-summary-product-purchases',
    title: t('spendSummary.productsPurchasesTitle'),
    titleVariant: 'section',
    layout: 'stacked',
    onDetailsClick: onOrderDetailsClick,
    visualization: {
        enabled: false,
        type: 'bar',
    },
    pagination: {
        mode: 'server',
        pageSize: 25,
        canLoadMore: canLoadMorePurchases,
        onLoadMore: loadMorePurchases,
    },
    table: {
        enabled: true,
        columns: [
            {
                id: 'date',
                label: t('Date'),
                valueKey: 'date',
                format: 'text',
                align: 'left',
            },
            {
                id: 'order',
                label: t('Order'),
                valueKey: 'orderNumber',
                format: 'text',
                align: 'left',
                bold: true,
                isDetailsTrigger: true,
            },
            {
                id: 'property',
                label: t('Property'),
                valueKey: 'propertyName',
                format: 'text',
                align: 'left',
            },
            {
                id: 'supplier',
                label: t('Supplier'),
                valueKey: 'supplierName',
                format: 'text',
                align: 'left',
            },
            {
                id: 'quantity',
                label: t('Quantity'),
                valueKey: 'quantity',
                format: 'number',
                align: 'right',
            },
            {
                id: 'spend',
                label: t('spendSummary.spend'),
                valueKey: 'spend',
                format: 'currency',
                align: 'right',
            },
        ],
        options: {
            emptyMessage: t('spendSummary.productsPurchasesEmpty'),
        },
    },
});
